module.exports = __webpack_public_path__ + "img/speaker.a0a20acd.svg";